import React from "react";
import Login from '../Pages/Login'
import Logout from '../Pages/Logout'
import Activate from '../Pages/Activate'
import ThreeDViewer from '../Pages/ThreeDViewer'
import Homepage from '../Pages/Homepage'
import Register from "../Pages/Register"
import PageNotFound from '../Pages/PageNotFound'
import FileUpload from "../Pages/Upload"

const routes =[
    {
        path:'/Login',
        component: Login,
        isPrivate: false
    },
    {
        path: '/Upload',
        component: FileUpload,
        isPrivate: true
    },
    {
        path:'/Logout',
        component: Logout,
        isPrivate: true
    },
    {
        path:'/3DViewer/:datasetP?/:leftDateP?/:viewTypeP?/:rightDateP?',
        //path:'/3DViewer',
        component: ThreeDViewer,
        isPrivate: false
    },
    {
        path:'/Activate',
        component: Activate,
        isPrivate: true
    },
    {
        path:'/Register',
        component: Register,
        isPrivate: false
    },
    {
        path:'/',
        component: Homepage,
        isPrivate: false
    },

    {
        path:'/*',
        component: PageNotFound,
        isPrivate: false
    },

]

export default routes
